import { useMemo, useState } from "react";

export const DEAL_FILTERS = [["all", "All"], ["sell", "Asks"], ["buy", "Bids"], ["funded", "Half-funded"]];
export const DEAL_SORTS = [["created_at", "Newest"], ["discount_pct", "Discount"], ["notional_usd", "Size"], ["saved", "Saved"]];

// Owns Deal Board filter/search/sort state and derives the visible, sorted rows.
export function useDealFilters(deals) {
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");
  const [sort, setSort] = useState("created_at");

  const rows = useMemo(() => {
    let r = deals || [];
    if (filter === "funded") r = r.filter((d) => d.status !== "open");
    else if (filter !== "all") r = r.filter((d) => d.side === filter);
    if (q) {
      const needle = q.toLowerCase();
      r = r.filter((d) => d.token_symbol.toLowerCase().includes(needle) || d.stock?.toLowerCase().includes(needle) || d.id.toLowerCase().includes(needle));
    }
    const key = (d) => (sort === "saved" ? d.slippage.saved_usd : sort === "created_at" ? new Date(d.created_at).getTime() : d[sort]);
    return [...r].sort((a, b) => key(b) - key(a));
  }, [deals, filter, q, sort]);

  return { rows, filter, setFilter, q, setQ, sort, setSort };
}
